import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {Alert, AlertTitle} from "@mui/material";

export default function AlertDialog({title, body, startsOpen=true, severity="error", onClose}) {
    const [open, setOpen] = React.useState(startsOpen);

    const handleClose = () => {
        setOpen(false);
        if (onClose) onClose()
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
        >
            <DialogContent  sx={{minWidth:'26em'}}>
                <Alert severity={severity}>
                    <AlertTitle>{title}</AlertTitle>
                    {body}
                </Alert>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} autoFocus>
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    )
}